import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer";
import React from "react";
import "./MM.css"

function MejoresMarcas() {
    return (<>
       
        <div class="wrapMarcas">

            <div className= "txtContentMarcas">
                <h2 className="TxtMarcas">Contamos con las marcas de mayor prestigio</h2>
            </div>

            <div className="slider">
            
            <div class="slideTrack">
                    <div className="box">
                        <img className="display-image" src="./Images/Atosa_Logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/cookrite Logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/Coriat Logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/CRT logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/Ferro Logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/imbera-logo-A4192D93D5-seeklogo.com.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/Logo Criotec.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/Metrology logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/migsa-logo.png"></img>
                    </div>
                        {/* slide two */}
            
                    <div className="box">
                        <img className="display-image" src="./Images/Atosa_Logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/cookrite Logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/Coriat Logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/CRT logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/Ferro Logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/imbera-logo-A4192D93D5-seeklogo.com.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/Logo Criotec.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/Logo Torrey.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/Metrology logo.png"></img>
                    </div>
                    <div className="box">
                        <img className="display-image" src="./Images/migsa-logo.png"></img>
                    </div>
            </div>
        </div>
        </div>

    </>
    )
}
export default MejoresMarcas 